// extracted by mini-css-extract-plugin
export default {"main":"layoutProfileBg_main__mrS7N","bigLogo":"layoutProfileBg_bigLogo__rtkxL","content":"layoutProfileBg_content__lvZAk"};